import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../i18n/I18nProvider';

const OTPTimer = ({ duration = 15 * 60, resendOTP, setResendOTP, setOtpExpired }) => { // Accept duration in seconds
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isExpired, setIsExpired] = useState(false);
  const { translations } = useTranslation()
  const de = translations.delivery
  useEffect(() => {
    if (resendOTP) {
      setTimeLeft(duration); // Reset timer when resendOTP is true
      setIsExpired(false);
      setOtpExpired?.(false);
      setResendOTP(false); // Reset resendOTP flag after restart
    }
  }, [resendOTP, duration, setResendOTP]);
  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true);
      setOtpExpired?.(true);
      return;
    }

    setOtpExpired?.(false);
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = String(timeLeft % 60).padStart(2, '0');


  return (
    <div>
      {!isExpired ? (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            color: '#444',
            marginTop: '10px',
            textAlign:'center'
          }}
        >
          {de.resendOTPin} <span style={{color: 'red'}}>{minutes} : {seconds}</span>
        </Typography>
      ) : (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            color: 'red',
            marginTop: '10px',
            textAlign:'center'
          }}
        >
          ❌ {de.pleaseResendOTP}
        </Typography>
      )}
    </div>
  );
};

export default OTPTimer;
